<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <div>
    <CCard>
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Dokumen Persyaratan Anggota Umum
        <Button
          :class="status_verifikasi == '1' ? 'btn btn-md btn-success px-4 py-2 ml-auto mr-2' : 'btn btn-md btn-secondary px-4 py-2 ml-auto mr-2' "
          :disabled="status_verifikasi != '1'"
          @click="kirimInvoice()"
        >Kirim Invoice</Button>
        <Button
          class="btn btn-md btn-dark px-4 py-2 text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <!-- Data dokumen -->
      <CCardBody>        
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable             
              style="widht:100% !important" 
              :items="items" 
              :fields="fields"
              :tableFilter='{ label:"Pencarian", placeholder:"Cari Data .." }'
              :items-per-page="10"
              :items-per-page-select='{ label : "Data Per Halaman"}'  
              hover 
              sorter
              :pagination='{ class: "float-right" }'>
              <template #no="{index}">
                <td class="py-2">{{ indexed == 0 ? index+1: index+indexed + 1 }}</td>
              </template>
              <template #nama_dokumen="{item}">
                <td class="py-2 text-left">{{item.nama_dokumen ? item.nama_dokumen : "-" }}</td>
              </template>
              <template #status_wajib="{item}">
                <td 
                  class="font-weight-bold text-left"
                  :class="{
                    'text-success': item.status_wajib == '1',
                    'text-danger': item.status_wajib == '0',
                  }"
                >
                  {{ item.status_wajib == '1' ? 'Wajib' : 'Tidak Wajib' }}
                </td>                   
              </template> 
              <template #status_upload="{item}">
                <td
                  class="font-weight-bold text-secondary"
                  v-if="item.status_upload == '0'"
                >Belum Upload</td>
                <td
                  class="font-weight-bold text-success"
                  v-if="item.status_upload ==   '1'"
                >Terverifikasi</td>
                <td
                  class="font-weight-bold text-primary"
                  v-if="item.status_upload ==   '2'"
                >Sudah Upload</td>
                <td
                  class="font-weight-bold text-info"
                  v-if="item.status_upload ==      '3'"
                >File Tidak Terbaca</td>
                <td
                  class="font-weight-bold text-danger"
                  v-if="item.status_upload ==    '4'"
                >File Tidak Sesuai</td>
              </template>
            

              <template #aksi="{item}">
                <td
                  class="py-2 text-center"
                  v-if="item.status_upload == 1
                  || item.status_upload == 2 || item.status_upload == 3 || item.status_upload == 4"
                >
                  <CButton
                    class="btn-sm text-white mr-2"
                    square
                    :color="item.file == ''?'info':'warning'"
                    :disabled="item.file == ''"
                    @click="lihatFile(item)"
                    v-c-tooltip="'Lihat File'"
                  >
                    <small><i class="fa fa-eye"  ></i></small>
                  </CButton>
                  <CButton
                    color="info"
                    class="btn-sm text-white"
                    square
                    v-c-tooltip="'Verifikasi'"
                    @click="verifikasiDokumen(item.id_dokumen_pendukung,item.status_upload,item.alasan)"
                  >
                  <small><i class="fa fa-check"  ></i></small>
                  </CButton>
                </td>
                <td class="py-2" v-else>
                  <CButton
                    class="btn-sm text-white mr-2"
                    square
                    :color="item.file == ''?'info':'warning'"
                    :disabled="item.file == ''"
                    @click="lihatFile(item)"
                    v-c-tooltip="'Lihat File'"
                  >
                    <small><i class="fa fa-eye"  ></i></small>
                  </CButton>
                  <CButton 
                  color="info" 
                  class="btn-sm text-white" 
                  square 
                  v-c-tooltip="'Verifikasi'"
                  disabled>
                  <small><i class="fa fa-check"  ></i></small>
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
        <CModal
          title="Modal title"
          :show.sync="lihatFileModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          
          <CRow>
            <div>
              <input type="file" @change="changeFileModal" accept="image/*,application/pdf"/>
              <object :data="blob" width="100%" height="700"/>
            </div>
          </CRow>
        </CModal>
        <!-- Modal Tambah -->
        <CModal
          title="Modal title"
          :show.sync="myModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm v-on:submit.prevent="postData">
            <CRow>
              <CCol sm="12">
                <label for class="font-weight-bold">Diverifikasi Pada</label>
                <br />
                <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
              </CCol>
              <CCol sm="12 mb-4">
                <label for class="font-weight-bold">Status</label>
                <br />
                <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                  <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                  <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                  <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
                </select>            
              </CCol>
              <CCol sm="12" v-if="formData.statusUpload != '1'">
                <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
                <textarea class="form-control" name="" id="" cols="30" rows="4" v-model="formData.alasan" placeholder="Masukkan alasan"></textarea>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Verifikasi Persyaratan Dokumen</h6>
          </template>
          <template #footer>
            <CButton @click="myModal = false" color="danger">Tutup</CButton>
            <CButton @click="postData" type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data BPK -->
    </CCard>
  </div>
</template>
<script>
import AnggotaUmumService from "../../../services/keanggotaan/anggota-umum/anggota-umum.service";
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";
import Utils from "../../../services/utils.service";
import { AlertUtils } from '../../../mixins/AlertUtils'

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "nama_dokumen",
    label: "Nama Dokumen",
    sorter: true,
    filter: true
  },
  {
    key: "status_wajib",
    label: "Status Dokumen",
    sorter: true,
    filter: false,    
  },
  {
    key: "status_upload",
    label: "Status Upload",
    sorter: true,
    filter: true
  },

  {
    key: "aksi",
    _style: "width:11%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL_FO_USER+"/",
      items: [],
      statusVerifikasi : 0,
      lihatFileModal : false,
      status_verifikasi : '0',
      formData: {
        idDokumenPendukungPeserta: '',        
        statusUpload: "",
        alasan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      fileName: "Choose File...",
      fields,      
      currentPage: 1,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      blob : null
    };
  },
  mounted() {
    this.getDataDokumen();
    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true,
          format: "YYYY-MM-DD"
        },
        function(start, end, label) {
          // comment console console.log(
                      
        }
      );
    });
  },
  methods: {
    kirimInvoice() {
       let loader = this.$loading.show({
        container: false ? null : this.$refs.$formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
      var formData = {
        idAnggotaUmum : this.$route.params.id_anggota_umum
      }

      AnggotaUmumService.sendInvoice(formData)
        .then(response => {
          loader.hide();          
          this.alertSuccess(response.data.message)
          // comment console console.log(response);
        })
        .catch(error => {
          loader.hide();
          this.alertError(error.response.data.message)
        });

    },
    changeFileModal(event) {
      const file = event.target.files[0]
      this.blob = URL.createObjectURL('https://localhost:9090/files?filename=UXUN-FMIAPICONTOH%20DOKUMEN.pdf&path=datamaster@informasiumum')
    },
    lihatFile(item) {

      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+item.file+"/lokasi/data_dokumen_pendukung/bearer/" + token,
        item.file,
        params
      );
    },

    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },

    getDataDokumen() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.$formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
      AnggotaUmumService.getDokumenPendukungAnggotaUmum(this.$route.params.id_anggota_umum)
        .then(response => {
          loader.hide();          
          this.items = response.data.singleData.data_dokumen;
          this.status_verifikasi = response.data.singleData.status_verifikasi
          // comment console console.log(response);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    verifikasiDokumen(
      id_dokumen_pendukung,
      status_upload,
      alasan
    ) {
      this.myModal = true;
      this.formData.idDokumenPendukungPeserta = id_dokumen_pendukung;
      this.formData.statusUpload = status_upload;
      this.formData.alasan = alasan;
      this.formData.verifikasiPada = tanggal_verifikasi;
      
    },

    postData() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.myModal = false;
          this.alertVerif();
          vm.getDataDokumen();
          loader.hide()
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide()
        });
    },
  }
};
</script>